import { TextFieldProps } from 'components/Form/TextField'
import { Primitive } from 'types/primitive'

export type PrebidModule = {
  account: PrebidModuleAccount
  id: string
  name: string
  parametersSchema: PrebidModuleParameter[]
}

export type PrebidModuleAccount = (typeof prebidModuleAccounts)[number]

export type PrebidModuleParameter = FieldProps & {
  type: Primitive
}

export type PrebidModuleType = (typeof prebidModuleTypes)[number]
type FieldProps = Pick<
  TextFieldProps<Record<string, unknown>>,
  'label' | 'name' | 'required' | 'tooltip'
>

export const prebidModuleAccounts = ['own', 'yieldbird'] as const
export const prebidModuleTypes = ['general', 'userId', 'vendorSpecific', 'analytics'] as const
